import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import type { SearchFilter, StreamDefinition } from '../../domain/model/Stream.types';
import * as api from './generated/api';
import { toApiCreateStreamDefinition, toStreamDefinitions } from './streams.mapper';

const baseUrl = `${import.meta.env.VITE_IOT_DATA_QUALITY_MONITOR_URL}`;

export type CreateStreamDefinition = {
    id: string;
    filter: SearchFilter;
};

const STREAM_DEFINITIONS_TAG = 'StreamDefinitions';

// Define a service using a base URL and expected endpoints
export const streamsApi = createApi({
    reducerPath: 'streamsApi',
    tagTypes: [STREAM_DEFINITIONS_TAG],
    baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders }),
    endpoints: builder => ({
        getAllStreams: builder.query<StreamDefinition[], void>({
            query: () => ({
                url: 'streams',
            }),
            transformResponse: (x: unknown) => {
                const response = api.StreamList.parse(x);
                return toStreamDefinitions(response);
            },
            providesTags: [STREAM_DEFINITIONS_TAG],
        }),
        putStreamDefinition: builder.mutation<void, CreateStreamDefinition>({
            query: item => ({
                url: `streams/${item.id}`,
                method: 'PUT',
                body: toApiCreateStreamDefinition(item),
            }),
            invalidatesTags: [STREAM_DEFINITIONS_TAG],
        }),
    }),
});

export const { useGetAllStreamsQuery, usePutStreamDefinitionMutation } = streamsApi;
